import { Component } from 'react';
import SideNav from '../sidenav/index';
import UserMenu from '../user-menu/index';
import NavBarFooter from './navbar/navbar-footer';
import igniteLogo from '../../assets/img/ignite_logo_alt.png';
import itukLogo from '../../assets/img/ITlogo-white.png';
import { USER_TYPE_ADMIN } from '../../data/userTypes';

class IgniteNavigation extends Component {
  state = {
    menuOpened: false,
  };

  handleToggle = () => {
    const { menuOpened } = this.state;

    this.setState({ menuOpened: !menuOpened });
  }

  render() {
    const {
      type, children, igniteLogoLink, hasRewardOutlet
    } = this.props;
    const { menuOpened } = this.state;
    const logoImage = hasRewardOutlet ? igniteLogo : itukLogo;

    return (
      <nav className="custom-sidebar navbar">
        <div className="container-fluid">
          <div className="navbar-header" id="navbar-header">
            <a
              className={`sidebar-brand ${hasRewardOutlet ? '' : 'ituk-logo'} navbar-brand`}
              href={igniteLogoLink || '/'}
            >
              <img alt="Ignite Logo" src={logoImage} title="Ignite logo"/>
            </a>
            <button
              type="button"
              className={`navbar-toggle${menuOpened ? '' : ' collapsed'}`}
              onClick={this.handleToggle}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"/>
              <span className="icon-bar"/>
              <span className="icon-bar"/>
            </button>
          </div>
          <SideNav type={type} menuOpened={menuOpened}/>
          <UserMenu type={type}/>
          {type !== USER_TYPE_ADMIN && <NavBarFooter type={type}/>}
          {children}
        </div>
      </nav>
    );
  }
}

export default IgniteNavigation;
